import { Instance, types } from 'mobx-state-tree';
import {
  RouteTimelineDtoModel, RouteTimelineDtoModelType, VisitDtoModel, VisitDtoModelType,
} from '../../models';
import { RouteDriverLocation } from '../../DriverLocation';

export const ItemsArray = types.model({
  unscheduledOrders: types.array(
    types.safeReference(types.late(() => VisitDtoModel), { acceptsUndefined: false }),
  ),
  stops: types.array(
    types.safeReference(types.late(() => RouteTimelineDtoModel), { acceptsUndefined: false }),
  ),
  driver: types.maybe(types.frozen<RouteDriverLocation>()),
}).views((self) => ({
  get isEmpty(): boolean {
    return !self?.unscheduledOrders.length && !self.stops.length;
  },
  get stopIds(): ReadonlySet<string> {
    return new Set(self.stops.map(stop => stop.id));
  },
  get scheduledOrders(): VisitDtoModelType[] {
    const orders = self.stops.flatMap((stop: RouteTimelineDtoModelType) => stop?.orders || []);
    return Array.from(new Map(orders.map(order => [order.id, order])).values());
  },
  get allOrders(): VisitDtoModelType[] {
    return [...self.unscheduledOrders, ...this.scheduledOrders];
  },
  get allOrdersCount(): number {
    return this.allOrders.length;
  },
}));

export type ItemsArrayModelType = Instance<typeof ItemsArray>;
